import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";

const getDepositQueue = createAsyncThunk(
  "deposits/getDepositQueue",
  async (_, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.get("/deposits/getDepositQueue", {
        headers,
      });

      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const getDepositHistory = createAsyncThunk(
  "deposits/getDepositHistory",
  async (dateRange, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/deposits/getDepositHistory",
        { dateRange },
        { headers }
      );

      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const getUserDepositHistory = createAsyncThunk(
  "deposits/getUserDepositHistory",
  async (userId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/deposits/getUserDepositHistory",
        { userId },
        { headers }
      );

      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const repeatDepositCallback = createAsyncThunk(
  "deposits/repeatDepositCallback",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/deposits/repeatDepositCallback",
        JSON.stringify(data),
        { headers }
      );

      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const getDepositMedia = createAsyncThunk(
  "deposits/getDepositMedia",
  async (transactionId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/deposits/getDepositMedia",
        { transactionId },
        { headers }
      );

      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const getDepositHistoryMedia = createAsyncThunk(
  "deposits/getDepositHistoryMedia",
  async (transactionId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/deposits/getDepositHistoryMedia",
        { transactionId },
        { headers }
      );

      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

export {
  getDepositQueue,
  getDepositHistory,
  getUserDepositHistory,
  repeatDepositCallback,
  getDepositMedia,
  getDepositHistoryMedia,
};
